import React,{ useState,useEffect } from 'react'
import {
    Card,
    CardBody,
    Row,
    Col,
    Input,
    FormGroup,
    UncontrolledTooltip,
    Button,
    
  } from "reactstrap";
  import Select from "react-select";
  import { MDBInput } from "mdb-react-ui-kit";
  import NotificationAlert from "react-notification-alert";
  import {sendRcs,BASE_URL_CHAT_APP,SMS_TMPLTS_SNDRIDS,WHATSAPP_INSTANT,WHATSAPP_TEMPLATE,CHANNEL_CLIENT_CHNLTYPE,INSTANT_RCS} from "../../constants"
  import axios from "axios";


  let userObj = localStorage.getItem("user");
  let user = JSON.parse(userObj);
  let initialvalues= {
    phoneNum:"",
    senderid:"",
    templateid:"",

  }


  let templates = [];
  let senderids = [];
const InstantRcs = () => {
  const [rcsdata,setRcsdata] = useState(initialvalues)
  const [channel, setChannel] = useState([]);
  const notificationAlertRef = React.useRef(null);
  const [isLoading, setIsLoading] = useState(true);
  const [errorhandle,setErrorHandle]= useState()
  useEffect(()=>{
    fetchChanelsbyClient();
 
  },[])
  


  const fetchChanelsbyClient=async()=>{
    setIsLoading(true)

    const payload={
      channels_type:"rcs",
      clintId:user?.client
    }
    user?.client!=0&&(await axios.post(CHANNEL_CLIENT_CHNLTYPE,payload).then(res=>{
    
      if(res?.data){
        setRcsdata(res?.data)
        setChannel(res?.data)
      templates=[]
      res?.data?.map((wtsap,i)=>{
        wtsap?.template&&templates.push({ value:wtsap?.template, label: wtsap?.template },)
        
      })
   
    }
      setIsLoading(false)
     }).catch(e=>{
     
      let options = {};
          options = {
            place: "tr",
            message: "Template Not Found",
            type: "warning",
            autoDismiss: 2,
          };
          notificationAlertRef?.current?.notificationAlert(options);
    }))

  }

  const changeSender=(data)=>{
    senderids=[]
      const chnl=channel.filter(item=>item.template==data.value)
      
      const senderid = chnl[0]?.senderid?.split(",");
          for(let i=0;i<senderid?.length;i++){
            senderids.push({label:senderid[i],value:senderid[i]})
          }
    setRcsdata(prev=>({...prev,templateid:data,senderid:""}))

  }
  const submitFields= async()=>{
    const isValid = validate();
    setErrorHandle(isValid)
    if(Object.keys(isValid).length==0){

      // {
      //   "username": "agpadmin",
      //   "password": "12345678",
      //   "sender": "YtiiJvC354qBORQz",
      //   "client_id":"19",
      //   "template": "test1",
      //   "message_body": { "otp": "123456", "validity": "10 mins" },
      //   "destination": "9949547410",
      //   "dynamic_params": { "param1": "value1" }
      //   }
    let payload={
      "username": localStorage.getItem("username"),
      "password":localStorage.getItem("password"),
      "sender": user?.sender_id,
      "client_id":user?.client.toString(),
      "message_body": { },
      "template":rcsdata?.templateid.value,
      "sender":rcsdata?.senderid.value,
      "destination":`91${rcsdata.phoneNum}`,
      "dynamic_params": { }
    }
    setIsLoading(true)
    await  axios.post(INSTANT_RCS,payload).then(res=>{
      let options = {};
      options = {
        place: "tr",
        message: "Sent Successfully",
        type: "success",

        autoDismiss: 2,
      };
      notificationAlertRef.current.notificationAlert(options);
      setRcsdata(initialvalues)
    
      }).catch(err=>{
        {
          let options = {};
          options = {
            place: "tr",
            message: "Backend Error",
            type: "warning",
    
            autoDismiss: 2,
          };
          notificationAlertRef.current.notificationAlert(options);
        }
      })
      setIsLoading(false)
    }
   }

   const validate=()=>{
   const num = rcsdata?.phoneNum?.split("")[0];
    let errors={}
    if(!rcsdata.phoneNum){
      errors.phoneNum="Please Enter Phone Number"
    } else if(rcsdata?.phoneNum?.length!=10){
      errors.phoneNum="Please Enter 10 Digits"
    }else if(num<=5||num=="-"||num=="+"||num=="e"){
      errors.phoneNum=`Number should not starts with ${num}`
    }
    if(!rcsdata?.templateid?.value){
      errors.templateid="Please Select Template"
    }
    if(!rcsdata?.senderid?.value){
      errors.senderid="Please Select Sender Id"
    }
    return errors;
   }
  return (
    <div className='content'>
        <Card>
            <CardBody>
            <NotificationAlert ref={notificationAlertRef} />
            <Row className="mb-4 ">
            <Col md="3" sm="12" className="mt-4 ">
          <MDBInput label="Mobile No" type="number" maxLength={10} value={rcsdata.phoneNum} name="mobileno"   onChange={(e)=>{ setRcsdata({
                        ...rcsdata,
                        phoneNum: e.target.value,
                      });}} />
                      <span style={{color:"red"}}>{errorhandle?.phoneNum}</span>
        </Col>
        
   
                  <Col md="4" sm="12">
          <p className="category">Select Template<suf style={{color:"red"}}>*</suf> </p>
          <Select
            className="react-select info"
            classNamePrefix="react-select"
            name="templateSelect"
            value={rcsdata.templateid}
            onChange={(value) => changeSender(value)}
            options={templates}
            placeholder="Select"
          />
          {errorhandle?.templateid&&<span style={{color:"red"}}>{errorhandle?.templateid}</span>}
        </Col>
        <Col md="4" sm="12">
          <p className="category">Select Sender</p>
          <Select
            className="react-select info"
            classNamePrefix="react-select"
            name="senderSelect"
            value={rcsdata?.senderid}
            onChange={(value) => setRcsdata(prev=>({...prev,senderid:value}))}
            options={senderids}
            placeholder="Select"
          />
           {errorhandle?.senderid&&<span style={{color:"red"}}>{errorhandle?.senderid}</span>}
        </Col> 
             
           
            <Col md="3" sm="3">
                <Button
                  color="primary "
                  className="mt-4 btn btn-icon animation-on-hover"
                  id="tooltipsubmit"
                  type="button"
                  disabled={isLoading}
                  onClick={() => submitFields()}
                >
                  <i className="tim-icons icon-double-right" />
                </Button>
                
              </Col>
            </Row>
            </CardBody>
        </Card>
    </div>
  )
}

export default InstantRcs
